import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const IconMenuMonitor = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="19" height="19" viewBox="0 0 19 19" fill="none">
            <path d="M16.625 1.58328H2.37502C1.50419 1.58328 0.791687 2.29578 0.791687 3.16662V12.6666C0.791687 13.5374 1.50419 14.2499 2.37502 14.2499H7.91669V15.8333H6.33335V17.4166H12.6667V15.8333H11.0834V14.2499H16.625C17.4959 14.2499 18.2084 13.5374 18.2084 12.6666V3.16662C18.2084 2.29578 17.4959 1.58328 16.625 1.58328ZM16.625 12.6666H2.37502V3.16662H16.625V12.6666Z" fill="#AEB4BE" />
        </SvgIcon>
    );
};